import { MatchingModel } from "../MatchingModel";
import { ActionResponse, ActionStatusHelper, RecordMap, useAuditEnricher } from "@/Shared";
import { useProperty, useNeed } from "@/OneLiners";
import { useSectorEnricher } from "@/Domains/Country";

export function useMatchingEnricher() {

    
    /**
     * Centralized audit enrichment hook
     * - Provides O(1) user resolution via precomputed Map
     * - Exposes audit enrichment helpers and status/error
     */
const {
    enricherResponse: auditEnricherResponse,
    userMap,
    getUserById,
    getEnrichedAudit,
} = useAuditEnricher<MatchingModel>();

    const { dataMap: propertyMap, stateResponse: propertyResponse } = useProperty();
    const { dataMap: needMap, stateResponse: needResponse } = useNeed();

    const {sectorMap, cityMap, countryMap, response : sectorEnricherResponse} = useSectorEnricher();

    const enricherResponse: ActionResponse = {
        status: ActionStatusHelper.combine(
            propertyResponse.status, 
            needResponse.status, 
            auditEnricherResponse.status,
            sectorEnricherResponse.status
        ),
        error: propertyResponse.error ?? 
        needResponse.error ?? 
        auditEnricherResponse.error ??
        sectorEnricherResponse.error
    };

    const getEnrichedMatchingMap = (matchingMap: RecordMap<MatchingModel>): RecordMap<MatchingModel> => {
        
        return matchingMap.map<MatchingModel>(getStrictEnrichedMatching);
    }


    const getEnrichedMatchingById = (matchingMap : RecordMap<MatchingModel>, 
        matchingId: number): MatchingModel | undefined => {
        return  getEnrichedMatching(matchingMap.get(matchingId)) ;
    }

    const getEnrichedMatching = (matching?: MatchingModel): MatchingModel | undefined => {
        if(!matching) return undefined;
        return getStrictEnrichedMatching(matching);
    }

    const getStrictEnrichedMatching = (matching: MatchingModel): MatchingModel => {
        return {
            ...getEnrichedAudit(matching),
            need: needMap.get(matching.needId),
            property: propertyMap.get(matching.propertyId),
        }
    }

    return {
        propertyMap,
        needMap,
        sectorMap,
        cityMap,
        countryMap,
        enricherResponse,
        getEnrichedMatching,
        getStrictEnrichedMatching,
        getEnrichedMatchingById,
        getEnrichedMatchingMap
    }
}

